<template>
  <div class="trust-pilot-badge">
    <a :href="trustPilotLink" class="trust-pilot-badge__link" rel="nofollow noreferrer noopener" target="_blank">
      <p class="trust-pilot-badge__rating-title">Excellent</p>

      <img
        class="trust-pilot-badge__rating-logo"
        src="./assets/trust-pilot-rating.svg"
        alt="Trust Pilot rating by starts"
        width="110"
        height="20"
        loading="lazy"
        decoding="async"
      />

      <div class="trust-pilot-badge__logo">
        <img
          src="./assets/trust-pilot-logo.svg"
          alt="Trust Pilot logo"
          width="18"
          height="18"
          loading="lazy"
          decoding="async"
        />
        <p class="trust-pilot-badge__logo-title">Trustpilot</p>
      </div>
    </a>
  </div>
</template>

<script>
const trustPilotLink = 'https://www.trustpilot.com/review/bravado.co';

export default {
  name: 'TrustPilotBadge',
  data: () => ({ trustPilotLink }),
};
</script>

<style lang="scss" scoped>
.trust-pilot-badge {
  margin-bottom: 40px;
  color: $white;
  font-size: 14px;
  position: relative;

  &__rating-title,
  &__rating-logo {
    margin-right: 11px;
  }

  svg {
    display: block;
    height: 100%;
  }

  &__logo {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    margin-right: 11px;

    &-title {
      line-height: 14px;
      margin-left: 3px;
      align-self: center;
    }
  }

  &__link {
    display: flex;
    align-items: center;
    width: fit-content;
    height: 20px;
    text-decoration: none;
  }
}
</style>
